import * as React from 'react';

import {FlashBanner} from '../flash-banner/flash-banner';
import type {MessageType} from '../message/message';

import styles from './status-header.module.css';

type Props = {
    type: MessageType;
    icon?: React.ReactElement<any> | null | undefined;
    content: React.ReactElement<any>;
};

export function StatusHeader(props: Props) {
    return (
        <FlashBanner type={props.type} animate={false} noRightPadding={true}>
            {props.icon ? props.icon : undefined}
            <span className={styles['header-text']}>{props.content}</span>
        </FlashBanner>
    );
}
